export default {
    type: 'testimonial-categories',
    aliases: {
        camel: 'testimonialCategories',
        singular: 'Testimonial category',
        plural: 'Testimonial categories',
        lowerSingular: 'testimonial category',
        lowerPlural: 'testimonial categories',
    },
    relations: {},
    publishable: true,
    adminSection: 'clients',
    componentType: 'base',
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPublishableCollection',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerTestimonialCategoryRecord',
            loader: () => import('./AdministerTestimonialCategoryRecord')
        },
    },
};
